// src/components/CookieConsent.js
import React from 'react';
import CookieConsent from 'react-cookie-consent';
import { useTheme, alpha } from '@mui/material/styles';
import { useMediaQuery } from '@mui/material';
import { useTranslation } from 'react-i18next';

const CookieConsentBanner = () => {
  const theme = useTheme();
  const { t } = useTranslation('general');
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  // Define styles based on screen size
  const bannerStyle = {
    background: alpha(theme.palette.primary.main, 0.95),
    padding: isMobile ? "6px 8px" : "8px 12px",
    alignItems: "center",
    minHeight: "auto",
    fontSize: isMobile ? "12px" : "13px",
    lineHeight: "1.3",
    zIndex: theme.components.MuiLayout.defaultProps.zIndex.cookieConsent,
    boxShadow: theme.shadows[2],
    display: "flex",
    flexWrap: isMobile ? "wrap" : "nowrap",
    gap: isMobile ? "6px" : "0"
  };

  const acceptButtonStyle = {
    background: theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText,
    fontSize: isMobile ? "11px" : "12px",
    padding: isMobile ? "3px 8px" : "4px 12px",
    borderRadius: theme.shape.borderRadius,
    marginLeft: isMobile ? "6px" : "12px",
    fontWeight: 500,
    cursor: "pointer",
    border: "none",
    whiteSpace: "nowrap"
  };

  const declineButtonStyle = {
    background: "transparent",
    border: `1px solid ${theme.palette.common.white}`,
    color: theme.palette.common.white,
    fontSize: isMobile ? "11px" : "12px",
    padding: isMobile ? "3px 8px" : "4px 12px",
    borderRadius: theme.shape.borderRadius,
    marginLeft: isMobile ? "4px" : "6px",
    fontWeight: 500,
    cursor: "pointer",
    whiteSpace: "nowrap"
  };

  const contentStyle = {
    margin: "0",
    flex: "1",
    color: theme.palette.primary.contrastText,
    fontSize: "inherit",
    lineHeight: "inherit",
    marginBottom: isMobile ? "4px" : "0",
    width: isMobile ? "100%" : "auto",
    order: isMobile ? 1 : 3
  };

  return (
    <CookieConsent
      location="bottom"
      buttonText={t('cookies.accept')}
      declineButtonText={t('cookies.decline')}
      enableDeclineButton
      style={bannerStyle}
      buttonStyle={acceptButtonStyle}
      declineButtonStyle={declineButtonStyle}
      contentStyle={contentStyle}
      overlayStyle={{
        background: alpha(theme.palette.common.black, 0.3),
        zIndex: theme.components.MuiLayout.defaultProps.zIndex.cookieConsent - 1
      }}
      expires={365}
    >
      {t('cookies.message')}
    </CookieConsent>
  );
};

export default CookieConsentBanner;